import { render, staticRenderFns } from "./JovianselcareGenerateToken.vue?vue&type=template&id=d5671908&"
import script from "./JovianselcareGenerateToken.vue?vue&type=script&lang=js&"
export * from "./JovianselcareGenerateToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports